export default {"src":"/_next/static/media/facebook-bold-color.99f44c86.svg","height":20,"width":13,"blurWidth":0,"blurHeight":0};